import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import DashboardComponent from './Components/Dashboard/DashboardComponent';
import Melt from './Components/Melt/Melt';
import Mould from './Components/Mould/Mould';
import OEECalculator from './Components/OEE/Oee';
import ThreeDPrinterUnit from './Components/Printer/Printer';
import Process from './Components/Process/Process';
import MainIndex from './Components/MainIndex/MainIndex';
import Login from './Components/Login/Login';
import LiveStream from './Components/LiveStream/LiveStream';
import URLDisplay from './Components/Printer/URLDisplay';
import EnergyAnalytics from './Components/EnergyAnalytics/EnergyAnalytics';

const ProtectedRoute = ({ children }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  if (!user) {
    return <Navigate to="/" replace />;
  }
  return children;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/home" element={
          <ProtectedRoute>
            <MainIndex />
          </ProtectedRoute>
        } />
        <Route path="/melt" element={
          <ProtectedRoute>
            <Melt />
          </ProtectedRoute>
        } />
        <Route path="/mould" element={
          <ProtectedRoute>
            <Mould />
          </ProtectedRoute>
        } />
        <Route path="/oee" element={
          <ProtectedRoute>
            <OEECalculator />
          </ProtectedRoute>
        } />
        <Route path="/printer" element={
          <ProtectedRoute>
            <ThreeDPrinterUnit />
          </ProtectedRoute>
        } />
        <Route path="/process" element={
          <ProtectedRoute>
            <Process />
          </ProtectedRoute>
        } />
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <DashboardComponent />
          </ProtectedRoute>
        } />

        <Route path="/energyanalytics" element={
          <ProtectedRoute>
            <EnergyAnalytics />
          </ProtectedRoute>
        } />

        <Route path="/live" element= {<LiveStream/>} />
        <Route path="/url" element= {<URLDisplay/>} />

      </Routes>
    </Router>
  );
}

export default App;